import React, { useMemo } from 'react';
import { EchartsWithTheme, useTheme } from '@maxtropy/components';
import { getChartOption } from './chartOption';
import { DateType } from '../TimeSelector';
import { V2HighEnergyDeviceAnalysisRuntimeTrendPostResponse } from '@maxtropy/device-customer-apis-v2';
import styles from './index.module.scss';

export interface RunStateDataItem {
  time?: number;
  runningTime?: number;
  standbyTime?: number;
  shutdownTime?: number;
  usageRate?: number;
}

export interface RunStateChartProps {
  data?: V2HighEnergyDeviceAnalysisRuntimeTrendPostResponse;
  timeResolution: DateType;
  runtimeTrendLoading: boolean;
}

const RunStateChart: React.FC<RunStateChartProps> = ({ data, timeResolution, runtimeTrendLoading }) => {
  const theme = useTheme();

  // 将API返回的数据转换为图表需要的格式
  const chartData = useMemo<RunStateDataItem[] | null>(() => {
    if (!data?.dataPoints) {
      // 如果没有数据，则返回空
      return null;
    }

    return data.dataPoints.map(dp => {
      const usageRate = dp.runningTimeRatio;

      return {
        time: dp.time,
        runningTime: dp.runningTime,
        standbyTime: dp.standbyTime,
        shutdownTime: dp.shutdownTime,
        usageRate,
      };
    });
  }, [data]);

  const chartOption = useMemo(() => {
    if (!chartData) return null;
    return getChartOption(chartData, timeResolution);
  }, [chartData, timeResolution]);

  return (
    <div className={styles.runStateChart}>
      <EchartsWithTheme
        loading={runtimeTrendLoading}
        empty={{ isShowEmpty: !chartData || chartData.length === 0 }}
        style={{ height: 320 }}
        option={chartOption}
        theme={theme}
      />
    </div>
  );
};

export default RunStateChart;
